/**
 * @deprecated use decimalPlacesDefaults instead. import from 'constants' conflicts with global node module,
 * resulting in error when this is imported by typescript.
 */
const constants = {
  percentageDecimalPlaces: 2,
  rateDecimalPlaces: 2,
  promileDecimalPlaces: 4,
};

export default constants;
